export enum WarrantyCoverageStatus {
  NO_DATA = -1,
  VALID = 0,
  EXPIRED = 1,
  CASE_OPEN = 2,
}

export const WarrantyCoverageStatusLabel: Record<
  WarrantyCoverageStatus,
  string
> = {
  [WarrantyCoverageStatus.NO_DATA]: 'No Data',
  [WarrantyCoverageStatus.VALID]: 'Warranty Valid',
  [WarrantyCoverageStatus.EXPIRED]: 'Warranty Expired',
  [WarrantyCoverageStatus.CASE_OPEN]: 'Potential Warranty Case',
};

export const WarrantyCoverageStatusCodeMap: Record<
  WarrantyCoverageStatus,
  WarrantyCoverageStatus
> = {
  [WarrantyCoverageStatus.NO_DATA]: WarrantyCoverageStatus.NO_DATA,
  [WarrantyCoverageStatus.VALID]: WarrantyCoverageStatus.VALID,
  [WarrantyCoverageStatus.EXPIRED]: WarrantyCoverageStatus.EXPIRED,
  [WarrantyCoverageStatus.CASE_OPEN]: WarrantyCoverageStatus.CASE_OPEN,
};

export function getWarrantyCoverageStatusFromCode(
  code: number,
): WarrantyCoverageStatus {
  return (
    WarrantyCoverageStatusCodeMap[code as WarrantyCoverageStatus] ??
    WarrantyCoverageStatus.NO_DATA
  );
}
